var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",style:({
    'width': _vm.percent+'%',
    'height': _vm.height,
    'background-color': _vm.canSuccess? _vm.color : _vm.failedColor,
    'opacity': _vm.show ? 1 : 0
  })})}
var staticRenderFns = []

export { render, staticRenderFns }